module.exports = __webpack_public_path__ + "media/assets/social-ig-f18500ad27492c463d2e29e866cc4ba8.png";